// The browser's offer to install Lantern as a desktop app (ADR-0014), kept
// from when it comes so a menu can make it later.

type InstallPrompt = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };

let offer: InstallPrompt | null = null;

if (typeof window !== "undefined") {
  addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    offer = e as InstallPrompt;
  });
  addEventListener("appinstalled", () => (offer = null));
}

// installed is whether Lantern runs as the installed app now.
export function installed(): boolean {
  return typeof matchMedia !== "undefined" && matchMedia("(display-mode: standalone)").matches;
}

// canInstall is whether the browser offers to install Lantern.
export const canInstall = () => offer !== null;

export async function install() {
  const o = offer;
  if (!o) return;
  offer = null;
  await o.prompt();
}
